import { SearchProduct } from "@nosto/nosto-js/client"

type DecoratedProduct = SearchProduct & { handle?: string }

export function handleDecorator(product: SearchProduct): DecoratedProduct {
  if (product.url) {
    const pathname = new URL(product.url).pathname
    // Remove trailing slash before extracting handle
    const normalizedPath = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname
    return {
      ...product,
      handle: normalizedPath.split("/").pop() || undefined
    }
  }
  return product
}
